import type * as React from 'react';
import { ConfirmDialog } from '@verclam/ui-kit';

type Props = {
	readonly visible: boolean;
	readonly onHide: () => void;
	readonly onAccept: () => void;
};

/** Reversible: the draft is emptied, and nothing is sent until "Enregistrer". */
const ClearFieldValueDialog: React.FC<Props> = ({ visible, onHide, onAccept }) => {
	return (
		<ConfirmDialog
			visible={visible}
			onHide={onHide}
			header="Vider ce champ ?"
			message="La valeur sera retirée du document."
			acceptLabel="Vider le champ"
			rejectLabel="Annuler"
			accept={onAccept}
		/>
	);
};

export default ClearFieldValueDialog;
